import { FileBrowser } from '../../components/FileBrowser/FileBrowser';

export function FilesPage() {
  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <FileBrowser catalog="files" />
    </div>
  );
}
